import React from 'react'
import styles from './UIGamePlayerInformation.module.scss'
import {type CardValidatorOrdered, type PlayerValidator} from '@colonist/game-mechanic-validators'
import {type MechanicCityImprovementsPlayerState} from '@colonist/game-states'
import clsx from 'clsx'
import {UIGamePlayerInformationUser} from './UIGamePlayerInformationUser/index.ts'
import {UIGamePlayerInformationCards} from './UIGamePlayerInformationCards/index.ts'
import {UIGamePlayerInformationProgress} from './UIGamePlayerInformationProgress/index.ts'
import {ModeSettingEnum} from '@colonist/types'

export interface UIGamePlayerInformationProps {
    gameMode: ModeSettingEnum
    isActive?: boolean
    playerValidator: PlayerValidator
    isCurrentUser: boolean
    translationContext: any
    amountOfResourceCards: number
    cardDiscardLimit: number
    knightDevelopmentCardsUsedCount: number
    hasLargestArmy: boolean
    longestRoadCount: number
    hasLongestRoad: boolean
    developmentCards: CardValidatorOrdered
    progressCards: CardValidatorOrdered
    victoryPointsToWin: number
    knightStrength: number
    hasHighestKnightStrength: boolean
    cityImprovementState: MechanicCityImprovementsPlayerState
    hasMerchant?: boolean
    isTakingAction?: boolean
    hasSpecialBuildPhaseFlag?: boolean
    hasRobber?: boolean
    className?: string
}

export const UIGamePlayerInformation = ({
    gameMode,
    isActive = false,
    playerValidator,
    isCurrentUser,
    translationContext,
    amountOfResourceCards,
    cardDiscardLimit,
    knightDevelopmentCardsUsedCount,
    hasLargestArmy,
    longestRoadCount,
    hasLongestRoad,
    developmentCards,
    progressCards,
    victoryPointsToWin,
    knightStrength,
    hasHighestKnightStrength,
    cityImprovementState,
    isTakingAction = false,
    hasMerchant = false,
    hasSpecialBuildPhaseFlag = false,
    hasRobber = false,
    className,
}: UIGamePlayerInformationProps) => {
    const isCityAndKnightMode = [
        ModeSettingEnum.CitiesAndKnights4P,
        ModeSettingEnum.CitiesAndKnights56P,
        ModeSettingEnum.CitiesAndKnightsSeafarers4P,
        ModeSettingEnum.CitiesAndKnightsSeafarers56P,
    ].includes(gameMode)

    const amountOfDevelopmentCards = isCityAndKnightMode ? progressCards.cards.length : developmentCards.cards.length

    return <div className={clsx(styles.container, className, {
        [styles.active]: isActive,
        [styles.currentUser]: isCurrentUser,
    })}>
        {isCurrentUser && <div className={styles.usernameLarge}>{playerValidator.userState.username}</div>}
        <div className={clsx(styles.informationWrapper, {
            [styles.active]: isActive,
        })}>
            <UIGamePlayerInformationUser
                hasMerchant={hasMerchant}
                hasSpecialBuildPhaseFlag={hasSpecialBuildPhaseFlag}
                isCurrentUser={isCurrentUser}
                isTakingAction={isTakingAction}
                playerValidator={playerValidator}
                victoryPointsToWin={victoryPointsToWin}
                hasRobber={hasRobber}
            />
            <UIGamePlayerInformationCards
                modeSetting={gameMode}
                amountOfDevelopmentCards={amountOfDevelopmentCards}
                amountOfResourceCards={amountOfResourceCards}
                cardDiscardLimit={cardDiscardLimit}
                isCityAndKnightMode={isCityAndKnightMode}
                isCurrentUser={isCurrentUser}
                progressCards={progressCards}
                translationContext={translationContext}
            />
            <UIGamePlayerInformationProgress
                cityImprovementState={cityImprovementState}
                hasHighestKnightStrength={hasHighestKnightStrength}
                hasLargestArmy={hasLargestArmy}
                hasLongestRoad={hasLongestRoad}
                isCityAndKnightMode={isCityAndKnightMode}
                isCurrentUser={isCurrentUser}
                knightDevelopmentCardsUsedCount={knightDevelopmentCardsUsedCount}
                knightStrength={knightStrength}
                longestRoadCount={longestRoadCount}
                translationKeyContext={translationContext}
                playerValidator={playerValidator}
            />
        </div>
    </div>
}
